var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #e8ba3a;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke: #193c34;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.387096774194106,
    y: 5.129032258064399,
    width: 239.2258064516118,
    height: 199.7419354838712
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path651",
    className: "cls-3",
    d: "M229.048585755196655,152.822673639580898v8.387086312650354c0,1.939384978169983-1.572182159543445,3.51156713770979-3.511567137706152,3.51156713770979h-64.368786426708539c-1.939384978159069,0-3.511567137706152-1.572182159539807-3.511567137706152-3.51156713770979v-46.520806251170143c0-1.939384978169983,1.572182159547083-3.51156713770979,3.511567137706152-3.51156713770979h64.368786426708539c1.939384978162707,0,3.511567137706152,1.572182159539807,3.511567137706152,3.51156713770979v38.133719938519789Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path655",
    className: "cls-3",
    d: "M193.352625404138053,164.721327089941042v19.632778193081322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path659",
    className: "cls-3",
    d: "M169.55531850342868,129.02536673888244v11.898653450349229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path663",
    className: "cls-3",
    d: "M205.25127885449092,129.02536673888244v11.898653450349229"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-3",
    d: "M181.453971953785185,123.076040013702368v17.847980175529301"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-3",
    d: "M193.352625404138053,134.974693464060692v5.949326725170977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path675",
    className: "cls-3",
    d: "M217.149932304847425,134.974693464060692v5.949326725170977"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path707",
    className: "cls-3",
    d: "M157.656665053075812,152.822673639580898h71.391920702120842"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 69.1619238581925,
    y: 36.765289023731384,
    width: 46.99781046844328,
    height: 26.002886939510063,
    rx: 3.396584989695839,
    ry: 3.396584989695839
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.159734326635771,53.978889203372091h17.94065342187605c1.639399514715478,0,2.968395406933269,1.328995892219609,2.968395406933269,2.968395406940544v13.843028965507983c0,1.63939951471184-1.32899589221779,2.96839540693145-2.968395406933269,2.96839540693145H51.221270436320083c-1.639399514717297,0-2.968395406933269-1.328995892219609-2.968395406933269-2.96839540693145v-13.843028965507983c0-1.639399514720935,1.328995892215971-2.968395406940544,2.968395406933269-2.968395406940544h17.940653421872412"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.86115942177912,
    y: 58.851691757532535,
    width: 11.391715607607694,
    height: 10.144336139359439
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6473514646114,53.978889203372091h11.843502763557066c.204377008840936,0,.370305209625904,.165928200784968,.370305209625904,.370305209625904v19.663167806492943c0,2.904818558604248-2.358344119866786,5.263162678471048-5.263162678471041,5.263162678471048h-2.057787849351154c-2.904818545647046,0-5.263162654994229-2.358344109347186-5.263162654994229-5.263162654994233v-19.663167829962205c0-.204377008845107,.16592820078835-.370305209633457,.370305209633454-.370305209633457Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.004718182558463,
    y1: 36.091140103071666,
    x2: 31.004718182558463,
    y2: 53.97888920337209
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.867803706228187,
    y1: 43.74754570193181,
    x2: 43.32977882710202,
    y2: 43.74754570193181
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137.0687831554451,
    y: 58.851691757532535,
    width: 11.391715607605875,
    height: 10.144336139359439,
    transform: "translate(285.529281918496054 127.847719654424495) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.723661416704687,53.978889203372091h2.057787845443357c2.904818555923754,0,5.263162673614289,2.358344117690557,5.263162673614289,5.263162673614303v19.663167811074743c0,.20437700899268-.165928200908183,.370305209900849-.370305209900863,.370305209900849h-11.843502778331697c-.204377008942458,0-.370305209809857-.165928200867398-.370305209809857-.370305209809857v-19.663167805795268c0-2.904818558887783,2.358344120096973-5.26316267898477,5.26316267898477-5.26316267898477Z",
    transform: "translate(309.505110735614892 133.254413957020859) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.3169400022698,
    y1: 36.091140103071666,
    x2: 154.3169400022698,
    y2: 53.97888920337209
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 166.45385447859644,
    y1: 43.74754570193181,
    x2: 141.99187935772989,
    y2: 43.74754570193181
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.885757206654489,73.758708982752069h37.550143771517469v6.608811542018884c0,1.289385034879004-1.046817057211385,2.336202092090389-2.336202092090389,2.336202092090389h-32.877739587336691c-1.289385034879004,0-2.336202092090389-1.046817057211385-2.336202092090389-2.336202092090389v-6.608811542018884h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.441549835161823,82.703822985731676c-.695915409611189,4.777925321670409-4.809797892903589,8.447351336069914-9.780720742750418,8.447351336069914-4.970931960568123,0-9.084820413007037-3.669439465080359-9.78072456913651-8.447377607069939"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.7493551915031,
    y: 185.04726246893642,
    width: 209.38284110065894,
    height: 14.315948286625826,
    rx: 5.987483057220673,
    ry: 5.987483057220673
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.158518446528433,166.090369641111465c1.063717772894961-2.932187586409782,7.751540598530482-18.890084804410435,25.470865755925843-12.88664468251045,.24391256798117,.082639405500231,.38462756946501,.344576967960165,.313660075784355,.592137520150573-.8540724711238,2.97931689007055-6.584701501935342,19.801277067219416-25.490637050775149,12.915751587639534-.251282721726966-.091516951310041-.385089063352098-.369846598909135-.293888780935049-.621244425279656Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.101135801748569,166.090369641111465c-1.063717772894051-2.932187586409782-7.751540598528663-18.890084804410435-25.470865755922205-12.88664468251045-.243912567982989,.082639405500231-.384627569466829,.344576967960165-.313660075787993,.592137520150573,.854072471125619,2.97931689007055,6.584701501933523,19.801277067219416,25.490637050779696,12.915751587639534,.251282721725147-.091516951310041,.38508906334846-.369846598909135,.293888780930502-.621244425279656Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.10113580174857,
    y1: 166.09036964111147,
    x2: 56.10113580174857,
    y2: 185.04726245950224
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.68917787558803,166.090369641111465c1.06371777289678-2.932187586409782,7.751540598528663-18.890084804410435,25.470865755927662-12.88664468251045,.243912567977532,.082639405500231,.384627569463191,.344576967960165,.313660075782536,.592137520150573-.854072471127438,2.97931689007055-6.584701501931704,19.801277067219416-25.490637050777877,12.915751587639534-.251282721725147-.091516951310041-.38508906334755-.369846598909135-.293888780932321-.621244425279656Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.631795230808166,166.090369641111465c-1.06371777289678-2.932187586409782-7.751540598528663-18.890084804410435-25.470865755927662-12.88664468251045-.243912567977532,.082639405500231-.384627569461372,.344576967960165-.313660075782536,.592137520150573,.854072471127438,2.97931689007055,6.584701501935342,19.801277067219416,25.490637050777877,12.915751587639534,.251282721725147-.091516951310041,.38508906334755-.369846598909135,.293888780932321-.621244425279656Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.63179523080817,
    y1: 166.09036964111147,
    x2: 114.63179523080817,
    y2: 185.04726245950224
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.2fb50353069af67223e0d9d93063ccff.svg";
export { ForwardRef as ReactComponent };